<app-page-heading [key]="'assets.list.page-title'"></app-page-heading>

<section class="container-fluid summary-panel">

    <app-data-table [columns]="columns" [sortColumn]="sortColumn" [loadPage]="loadPage" [(filters)]="filters"
                    [filtersComponent]="dataFilters" (onLoad)="pageLoaded()">
        <app-data-filters #dataFilters [fullWidth]="true" [opened]="true">
            <app-data-filter-group [useAvailableWidth]="true">

                <app-data-filter-input [labelKey]="'assets.list.filters.glid.label'" [(model)]="filters.glid"
                                       [placeholderKey]="'assets.list.filters.glid.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'assets.list.filters.user-email.label'" [(model)]="filters.userEmail"
                                       [placeholderKey]="'assets.list.filters.user-email.placeholder'"></app-data-filter-input>

                <app-data-filter-date [labelKey]="'assets.list.filters.reported-at-start.label'" [(model)]="startDate"
                                      [placeholderKey]="'assets.list.filters.reported-at-start.placeholder'" [maxDate]="endDate"
                                      (modelChange)="updateStartDateFilter()"></app-data-filter-date>

                <app-data-filter-date [labelKey]="'assets.list.filters.reported-at-end.label'" [(model)]="endDate"
                                      [placeholderKey]="'assets.list.filters.reported-at-end.placeholder'" [minDate]="startDate"
                                      (modelChange)="updateEndDateFilter()"></app-data-filter-date>

            </app-data-filter-group>
            <app-data-filters-button [labelKey]="'assets.list.filters.export'" [type]="'primary'"
                                     (onClick)="openConfirmExportAssets(exportAssetsModal)">
                <i class="fa fa-download"></i>
            </app-data-filters-button>
        </app-data-filters>
    </app-data-table>

</section>


<ng-template #exportAssetsModal>
    <span [i18n]="[{target: 'innerHTML', key: 'assets.modals.export.body'}]"></span>
</ng-template>


<ng-template #reportedAtColumn let-reportedAt="reportedAt">
    <span [title]="reportedAt | fullDate">{{ reportedAt | dateDiffFromNow | async }}</span>
</ng-template>

<ng-template #locationColumn let-location="location">
    <a class="cmaweb-link" [href]="link.goToLocationGlid(location.glid)" target="_blank">{{ location.glid + ' - ' + location.name }}</a>
</ng-template>

<ng-template #userEmailColumn let-userEmail="userEmail" let-userRole="userRole">
    {{ userEmail }}
</ng-template>

<ng-template #companyNameColumn let-carrierName="carrierName" let-userRole="userRole">
    <a class="userBadge _{{userRole}} cmaweb-link" *ngIf="userRole === 'DRIVER' && carrierName" [href]="link.goToCarrierName(carrierName, false)" target="_blank">{{carrierName}}</a>
    <div class="userRole" *ngIf="!carrierName">
        <span class="userBadge _{{userRole}}">
            <i class="fa"></i><span>{{userRole === "DRIVER" ? translate.instant('user-table.carrier') : "CHEP" }}</span>
        </span>
    </div>
</ng-template>

<ng-template #productColumn let-item="item">
    {{ item.productCode + ' - ' + item.productDescription }}
</ng-template>

<ng-template #quantityColumn let-quantity="quantity">
    {{ quantity }}
</ng-template>

<ng-template #shipmentsColumn let-deliveryNumbers="deliveryNumbers">
    <ng-container *ngIf="deliveryNumbers?.length > 0; else emptyDeliveryNumbers">
        <a *ngIf="canAccessLoadManagementScreen; else displayOnly"
           class="cmaweb-link"
           [href]="link.goToLoadManagementForDelivery(deliveryNumbers.join(', '))"
           target="_blank">
            {{ deliveryNumbers.join(', ') }}
        </a>
        <ng-template #displayOnly>
            <span>{{ deliveryNumbers }}</span>
        </ng-template>
    </ng-container>
    <ng-template #emptyDeliveryNumbers>
        <span>/</span>
    </ng-template>

</ng-template>

<ng-template #vehicleColumn let-vehicle="vehicle">
    {{ vehicle }}
</ng-template>
